<template>
  <div class="mb-4 mt-4 border-bottom">
    <h1 class="d-flex d-sm-block">
      <router-link to="/"><img src="https://www.gravatar.com/avatar/cb357810cd16a7f03f21d5dbe539d0f0?s=80" width="80" height="80" alt="n3t" /></router-link>
      <span class="ms-4">n3t Joomla! Extensions</span>
    </h1>
  </div>
</template>
